"use strict";

exports.__esModule = true;

exports.default = function (value) {
  return value == null;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/util/isAbsent.js
// module id = 54
// module chunks = 68205460534756